export default "__VITE_ASSET__eccf524c__"